import {
  Destination,
  type SubwayContent as SubwayContentType,
} from '../../../../../shared/types'
import styles from './SubwayContent.module.scss'

import { parentMeta } from '../../type'
import useSubwayContent from './useSubwayContent'
import { Button, Loading } from '../../../../common'
import { CopyContainer } from '../../../../common/copy'
import Actions from '../../../../Actions/Actions'

interface SubwayContentProps {
  parentMeta?: parentMeta
  content: SubwayContentType
  filePath?: string
}

const SubwayContent = (props: SubwayContentProps) => {
  const { content } = props
  const { destinations, loading, error, actions } = useSubwayContent()

  console.log('subway content', content)

  console.log('destinations', destinations)

  return (
    <Loading loading={loading} fullscreen message="Loading Subway...">
      <div className={styles.subwayContentRoot}>
        {actions && <Actions actions={actions} />}
      </div>
    </Loading>
  )
}

export default SubwayContent
